<template>
  <tlbs-map
    ref="mapRef"
    api-key="7IFBZ-I4OYT-F3PXC-VDVE6-5OTT3-KVBRU"
    :center="center"
    :zoom="zoom"
    :control="control"
    @click="onClick"
    @map_inited="onMapInited"
  >
    <tlbs-multi-marker
      ref="markerRef"
      :geometries="geometries"
      :styles="styles"
      :options="options"
    />
    <tlbs-info-window
      ref="infoWindowRef"
      :visible="visible"
      :position="center"
      :content="centent"
      :options="{
        offset: {
          x: 0,
          y: 0,
        },
      }"
    />
  </tlbs-map>
</template>
<script>
import { defineComponent, toRef, ref } from "vue";

export default defineComponent({
  name: "MarkerDemo",
  props: {
    content: {
      type: String,
      default: "111111",
    },
    centerlat: {
      type: Number,
      default: 24.522969,
    },
    centerlng: {
      type: Number,
      default: 117.619038,
    },
  },
  setup(props) {
    const mapRef = ref(null);
    const markerRef = ref(null);
    const infoWindowRef = ref(null);
    const center = toRef({ lat: props.centerlat, lng: props.centerlng });
    const zoom = ref(15);
    const visible = ref(true);
    const centent = toRef(props.content);
    const onClick = (e) => {
      console.log(e);
      console.log("centent--------", props.content);
    };

    const onMapInited = () => {
      // 地图加载完成后，可以获取地图实例、点标记实例，调用地图实例、点标记实例方法
      console.log("map-------", mapRef.value.map);
      console.log("marker-------", markerRef.value.marker);
      console.log("infoWindow-------", infoWindowRef.value.infoWindow);
    };

    const getLayerInstance = () => {
      // 可以获取点标记实例，调用点标记实例方法
      console.log(markerRef.value.marker);
      console.log(infoWindowRef.value.infoWindow);
    };

    return {
      centent,
      visible,
      center,
      zoom,
      onClick,
      onMapInited,
      getLayerInstance,
      infoWindowRef,
      control: {
        scale: {},
        zoom: {
          position: "topRight",
        },
      },
      mapRef,
      markerRef,
      geometries: [{ styleId: "marker", position: { lat: 39.91799, lng: 116.397027 } }],
      styles: {
        marker: {
          width: 20,
          height: 30,
          anchor: { x: 10, y: 30 },
        },
      },
      options: {
        minZoom: 5,
        maxZoom: 15,
      },
    };
  },
});
</script>

<style scoped>
.control-container {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1001;
  display: flex;
  align-items: center;
}
button {
  padding: 4px;
  background-color: #fff;
  margin-right: 5px;
  border: 1px solid #ddd;
}
</style>
